import { icon } from "leaflet";
import { all_routes } from "../../../feature-module/router/all_routes";
const route = all_routes;

export const getSidebarData = (
  userRole?: string,
  selectedTenantId?: string | null
) => {
  const isSuperAdmin =
    userRole?.toLowerCase() === "superadmin" ||
    userRole?.toLowerCase() === "super_admin" ||
    userRole?.toLowerCase() === "platform_analyst" ||
    userRole?.toLowerCase() === "platformanalyst" ||
    userRole?.toLowerCase() === "apiadmin" ||
    userRole?.toLowerCase() === "api_admin";

  if (isSuperAdmin) {
    const mainMenuItems = [
      {
        label: "MAIN MENU",
        submenuOpen: true,
        showSubRoute: false,
        submenuHdr: "Main",
        submenuItems: [
          {
            label:
              userRole?.toLowerCase() === "superadmin" ||
                userRole?.toLowerCase() === "super_admin"
                ? "Super Admin"
                : userRole?.toLowerCase() === "apiadmin" ||
                  userRole?.toLowerCase() === "api_admin"
                  ? "API Admin"
                  : "Platform Analyst",
            icon: "ti ti-shield-check",
            submenu: true,
            showSubRoute: true,
            submenuItems: [
              {
                label: "Dashboard",
                icon: "ti ti-dashboard",
                submenu: false,
                showSubRoute: false,
                link: route.dealsDashboard,
                defaultSelected: true,
              },
              {
                label: "Subscriptions",
                icon: "ti ti-credit-card",
                submenu: false,
                showSubRoute: false,
                link: route.superadminSubscription,
              },
              {
                label: "User Management",
                icon: "ti ti-user-star",
                submenu: false,
                showSubRoute: false,
                link: route.userManagementSuperAdmin,
              },
            ],
          },
        ],
      },
    ];

    const settingsMenuItems: any[] = [
      {
        label: "Profile Settings",
        icon: "ti ti-user-cog",
        submenu: false,
        showSubRoute: false,
        link: route.profile,
        subLink1: route.security,
        subLink2: route.emailSettings,
        subLink3: route.chatSettings,
        subLink4: route.calendarSettings,
      },
    ];

    if (
      userRole?.toLowerCase() === "superadmin" ||
      userRole?.toLowerCase() === "super_admin"
    ) {
      settingsMenuItems.push({
        label: "AI Configuration",
        icon: "ti ti-robot",
        submenu: false,
        showSubRoute: false,
        link: route.aiConfiguration,
        subLink1: route.aiConfigurationCrmLevel,
        subLink2: route.aiConfigurationTenantLevel,
        subLink3: route.aiConfigurationUsageLogs,
      } as any);
    }

    if (selectedTenantId) {
      settingsMenuItems.push(
        {
          label: "Organization Settings",
          icon: "ti ti-world-cog",
          submenu: false,
          showSubRoute: false,
          link: route.companySettings,
          subLink1: route.leadssettings,
          subLink2: route.pipelinesettings,
          subLink3: route.dealssettings,
          subLink4: route.proposalssettings,
          subLink5: route.contractssettings,
          subLink6: route.importSettings,
          subLink7: route.productServices,
          subLink8: route.customFields,
          subLink9: route.importData,
          subLink10: route.auditLog,
        },
        {
          label: "Access & Subscription",
          icon: "ti ti-lock-dollar",
          submenu: false,
          showSubRoute: false,
          link: route.accessManagement,
          subLink1: route.userManagement,
          subLink2: route.teamManagement,
          subLink3: route.subscriptionmanagement,
        },
      );
    }


    if (
      userRole?.toLowerCase() === "apiadmin" ||
      userRole?.toLowerCase() === "api_admin"
    ) {
      settingsMenuItems.push({
        label: "API Integration",
        icon: "ti ti-api",
        submenu: false,
        showSubRoute: false,
        link: route.adminApiIntegrationSettings,
      });
    }

    settingsMenuItems.push({
      label: "Organization Management",
      icon: "ti ti-building-community",
      submenu: false,
      showSubRoute: false,
      link: route.tenantManagement,
    });



    mainMenuItems.push({
      label: "Settings",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Settings",
      submenuItems: settingsMenuItems,
    });

    return mainMenuItems;
  }

  return [
    {
      label: "MAIN MENU",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Dashboard",
          icon: "ti ti-layout-2",
          submenu: false,
          showSubRoute: false,
          link: route.dealsDashboard,
        },
        {
          label: "Analytics",
          icon: "ti ti-chart-bar",
          submenu: true,
          showSubRoute: true,
          submenuItems: [
            {
              label: "Summary Report",
              icon: "ti ti-report",
              submenu: false,
              showSubRoute: false,
              link: route.analytics,
            },
            {
              label: "Revenue Summary",
              icon: "ti ti-report-money",
              submenu: false,
              showSubRoute: false,
              link: route.revenueSummary,
            },
            {
              label: "Sales Overview",
              icon: "ti ti-presentation-analytics",
              submenu: false,
              showSubRoute: false,
              link: route.salesSummary,
            },
            {
              label: "Activities Report",
              icon: "ti ti-list-check",
              submenu: false,
              showSubRoute: false,
              link: route.analyticsActivitiesReport,
            },
            {
              label: "Chat Analytics",
              icon: "ti ti-message-2",
              submenu: false,
              showSubRoute: false,
              link: route.analyticsChatAnalytics,
            },
          ],
        },
      ],
    },
    {
      label: "Applications",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Applications",
      submenuItems: [
        {
          label: "Email",
          icon: "ti ti-mail",
          submenu: false,
          showSubRoute: false,
          link: route.email,
          subLink1: route.emailImportant,
          subLink2: route.emailSent,
          subLink3: route.emailDetail,
        },
        {
          label: "Chat",
          icon: "ti ti-message",
          submenu: false,
          showSubRoute: false,
          link: route.chat,
        },
        {
          label: "Calendar",
          icon: "ti ti-calendar",
          submenu: false,
          showSubRoute: false,
          link: route.calendar,
          subLink1: route.externalTasks
        },
      ],
    },
    {
      label: "CRM",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Inventory",
      submenuItems: [
        {
          label: "Companies",
          link: route.companies,
          subLink1: route.companyDetails,
          subLink2: route.companiesGrid,
          icon: "ti ti-building-community",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Contacts",
          link: route.contactList,
          subLink1: route.contactGrid,
          subLink2: route.contactDetails,
          icon: "ti ti-user-up",
          showSubRoute: false,
          submenu: false,
        },
        {
          label: "Leads",
          link: route.leads,
          subLink1: route.leadsList,
          subLink2: route.leadsKanban,
          icon: "ti ti-chart-arcs",
          showSubRoute: false,
          submenu: false,
          lifecycleTypeKey: "LEAD",
        },
        {
          label: "Pipeline",
          link: route.pipelines,
          subLink1: route.pipelineDetails,
          subLink2: route.pipelinesKanban,
          icon: "ti ti-timeline-event-exclamation",
          showSubRoute: false,
          submenu: false,
          lifecycleTypeKey: "PIPELINE",
        },
        {
          label: "Deals",
          link: route.deals,
          subLink1: route.dealsKanban,
          subLink2: route.dealsDetails,
          icon: "ti ti-medal",
          showSubRoute: false,
          submenu: false,
          lifecycleTypeKey: "DEAL",
        },
        {
          label: "Proposals",
          link: route.proposals,
          subLink1: route.proposalsGrid,
          subLink2: route.proposalsDetails,
          icon: "ti ti-file-text",
          showSubRoute: false,
          submenu: false,
          lifecycleTypeKey: "PROPOSAL",
        },
        {
          label: "Contracts",
          link: route.contracts,
          subLink1: route.contractsGrid,
          subLink2: route.contractsDetails,
          icon: "ti ti-file-certificate",
          showSubRoute: false,
          submenu: false,
          lifecycleTypeKey: "CONTRACT",
        },
        {
          label: "Tasks",
          link: route.tasks,
          icon: "ti ti-calendar-event",
          showSubRoute: false,
          submenu: false,
        },
      ],
    },
    {
      label: "Settings",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Settings",
      submenuItems: [
        {
          label: "Profile Settings",
          icon: "ti ti-user-cog",
          submenu: false,
          showSubRoute: false,
          link: route.profile,
          subLink1: route.security,
          subLink2: route.emailSettings,
          subLink3: route.apiIntegrationSettings,
          subLink4: route.taskNotificationSettings,
          subLink5: route.notificationSettings,
          subLink6: route.chatSettings,
          subLink7: route.calendarSettings,
          subLink8: route.autoCreationRules,
        } as any,
        {
          label: "Organization Settings",
          icon: "ti ti-world-cog",
          submenu: false,
          showSubRoute: false,
          link: route.companySettings,
          subLink1: route.leadssettings,
          subLink2: route.pipelinesettings,
          subLink3: route.dealssettings,
          subLink4: route.proposalssettings,
          subLink5: route.contractssettings,
          subLink6: route.importSettings,
          subLink7: route.productServices,
          subLink8: route.customFields,
          subLink9: route.importData,
          subLink10: route.auditLog,
          subLink11: route.approvalPolicy,
          subLink12: route.sourceSettings,
          subLink13: route.lifecycleStatusReasonLost,
          subLink14: route.lifecycleStatusReasonWon,
          subLink15: route.workflowConfiguration,
          subLink16: route.salesActivityType,
        } as any,
        ...(userRole &&
          (userRole.toLowerCase() === "clientadmin" ||
            userRole.toLowerCase() === "client_admin")
          ? [
            {
              label: "Access & Subscription",
              icon: "ti ti-lock-dollar",
              submenu: false,
              showSubRoute: false,
              link: route.accessManagement,
              subLink1: route.userManagement,
              subLink2: route.teamManagement,
              subLink3: route.subscriptionmanagement,
              subLink4: route.storage,
            } as any,
          ]
          : []),
      ],
    },
  ];
};
